export const getContainerScale = (el: HTMLDivElement, height = 1080, width = 1920) => {
  const parentRect = el.parentElement?.getBoundingClientRect();
  return Math.min((parentRect?.width || width) / width, (parentRect?.height || height) / height);
};
